import React from "react";
import { Link } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import AboutUs from "./About-us";
import ContactUs from "./Contact-us";

const Footer = () => (
  <Box component="footer" bgcolor="primary.main" color="primary.contrastText" py={4}>
    <Container maxWidth="md">
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <AboutUs />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ContactUs />
        </Grid>
      </Grid>
    </Container>
    <Box textAlign="center" mt={2}>
      <Link
        to="/politicas-privacidad"
        style={{ color: "#fff", textDecoration: "none" }}
      >
        <Button style={{ color: "inherit" }}>
          Políticas de privacidad, políticas de reembolso, términos y condiciones
        </Button>
      </Link>
    </Box>
  </Box>
);

export default Footer;
